import {createContext} from 'react'

const PacientesContext = createContext()

export default PacientesContext